/**
 * Swap which object is the start and which is the end.
 * Bound ends swap terminals. A free end follows by swapping the stored points.
 */
export function reverseArrowConnection(editor, arrowId) {
  if (!editor || !arrowId || editor.getIsReadonly?.()) return false;
  const shape = editor.getShape?.(arrowId);
  if (!shape || shape.type !== 'arrow') return false;

  const bindings = editor.getBindingsFromShape?.(arrowId, 'arrow') || [];
  const start = bindings.find(binding => binding?.props?.terminal === 'start');
  const end = bindings.find(binding => binding?.props?.terminal === 'end');

  const apply = () => {
    const updates = [];
    if (start) {
      updates.push({
        ...start,
        props: { ...start.props, terminal: 'end' },
      });
    }
    if (end) {
      updates.push({
        ...end,
        props: { ...end.props, terminal: 'start' },
      });
    }
    if (updates.length) {
      if (typeof editor.updateBindings === 'function') {
        editor.updateBindings(updates);
      } else {
        updates.forEach(binding => editor.updateBinding?.(binding));
      }
    }

    const startPoint = shape.props?.start || { x: 0, y: 0 };
    const endPoint = shape.props?.end || { x: 0, y: 0 };
    editor.updateShape?.({
      id: arrowId,
      type: 'arrow',
      props: {
        ...shape.props,
        start: endPoint,
        end: startPoint,
        arrowheadStart: 'none',
        arrowheadEnd: 'arrow',
      },
    });
  };

  if (typeof editor.run === 'function') editor.run(apply);
  else apply();
  return true;
}
